






































import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _, { Dictionary } from "lodash";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import CuratedRtqInstrumentsPieChart from "@/employee/components/investments/drivewealth/CuratedRtqInstrumentsPieChart.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";

@Component({
  components: {
    InstrumentName,
    CuratedRtqInstrumentsPieChart,
    GenericLoadingSpinner
  }
})
export default class CuratedRtqInstumentsTable extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;

  drivewealthStore = useDrivewealthStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();

  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop({ required: false }) accountId: number;
  @Prop({ required: false }) instrumentListId: number;

  @Watch("riskToleranceQuestionnaireStore.instrumentListId")
  reload (): void {
    if (this.riskToleranceQuestionnaireStore.instrumentListId) {
      this.loadCuratedRtqInstruments({force: true});
    }
  }

  mounted (): void {
    if (this.accountId) {
      this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
    }
    if (this.riskToleranceQuestionnaireStore.instrumentListId) {
      this.loadCuratedRtqInstruments({force: true});
    }
  }

  loadCuratedRtqInstruments (options: { force?: boolean }): void {
    this.drivewealthStore.loadCuratedRtqInstruments({
      username: this.username,
      partnerId: this.partnerId,
      instrumentListId: this.riskToleranceQuestionnaireStore.instrumentListId,
      force: options.force
    });
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.curatedRtqInstrumentsLoaded;
  }

  tableFields = [
  {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Investment"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center text-capitalize"
    },
  ];

  get fundItems () {
    if (!this.drivewealthStore.curatedRtqInstruments) {
      return [];
    }

    const mappedInstruments = this.drivewealthStore.curatedRtqInstruments.map(f => ({
      stock_symbol: f.stockSymbol,
      instrument: { symbol: f.stockSymbol, companyName: f.companyName, website: f.website, imageUrl: f.imageUrl },
      status: f.status,
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(f.fundType),
      assetCategoryName: f.assetCategoryName,
      allocationPercentage: f.allocationPercentage,
      balance: "0",
      shares: "0",
      percentage: "0",
      action: { symbol: f.stockSymbol }
    }));

    return mappedInstruments;
  }

  get groupedInstrumentDetails (): Dictionary<any[]> {
    const orderedResult = _.orderBy(this.fundItems, "allocationPercentage", "desc");
    const groupedResult = _.groupBy(orderedResult, "assetCategoryName");

    return groupedResult;
  }

  getInstrumentListAssetCategory (instrumentList: any[]): string {
    if (!instrumentList || !instrumentList.length) {
      return "";
    }

    const instrument = _.head(instrumentList);

    return instrument.assetCategoryName;
  }

  getInstrumentListHeading (instrumentList: any[]): string {
    if (!instrumentList || !instrumentList.length) {
      return "";
    }

    const instrument = _.head(instrumentList);

    if (!instrument.assetCategoryName && !instrument.allocationPercentage) {
      return "";
    }

    return `${instrument.assetCategoryName} - ${instrument.allocationPercentage}%`;
  }

  isInstrumentListOtherCategory (instrumentList: any[]): boolean {
    if (!instrumentList || !instrumentList.length) {
      return false;
    }

    const instrument = _.head(instrumentList);

    if (instrument.assetCategoryName && instrument.allocationPercentage === 0) {
      return true;
    }

    return false;
  }
}
